<template>
  <div class="contact-page">
    <div class="contact-header">
      <h1>CONTACTEZ-NOUS</h1>
     
    </div>
     <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/contact">Contact</a>
      </div>
    <div class="contact-content">
      <div class="contact-info">
        <h2>Approche</h2>
        <!-- Intégration de Google Maps pour l'adresse spécifique -->
        <div class="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d25623.568722439293!2d-7.5883094!3d33.5757493!3m2!1i1024!2i768!4f13.1!2m1!1s12%20Bd%20Hassan%20Al%20Alaoui%20R%C3%A9s.%20Nissrine%20%E2%80%93%20Ain%20Borja%2C%20Casablanca.!5e1!3m2!1sfr!2sma!4v1725041306677!5m2!1sfr!2sma" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            width="100%" 
            height="300" 
            frameborder="0" 
            style="border:0;" 
            allowfullscreen="" 
            aria-hidden="false" 
            tabindex="0">
          </iframe>
        </div>
    
        <ul>
          <li><strong>Téléphone :</strong> +212 5 22 60 05 06 / +212 5 22 62 05 07</li>
          <li><strong>Email :</strong> info@supracare.ma</li>
          <li><strong>Horaires :</strong> Lundi à Vendredi: 08h30 - 12h30 </li>
          <li>Après midi : 14h30 - 18h30</li>
             <li>Samedi : 08h30 - 12h30</li>
        </ul>
      </div>
      <div class="contact-form">
        <h2>Contact</h2>
        <p>Vous pouvez nous contacter de la manière qui vous convient. Nous sommes disponibles par fax, e-mail ou téléphone. Vous pouvez également utiliser un formulaire de contact rapide ci-dessous ou vous rendre personnellement à notre bureau.

Envoyez-nous un e-mail pour toute question ou demande de renseignements ou utilisez nos coordonnées. Nous serons heureux de répondre à vos questions.</p>
     
<form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="name">Nom</label>
            <input type="text" id="name" v-model="form.name" required />
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="form.email" required />
          </div>
          <div class="form-group">
            <label for="message">Message</label>
            <textarea id="message" v-model="form.message" required></textarea>
          </div>
          <button type="submit">Envoyer</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Formulaire soumis avec les données :", this.form);
      this.form.name = '';
      this.form.email = '';
      this.form.message = '';
    }
  }
};
</script>

<style scoped>
/* ================== Variables ================== */
:root{
  --brand: #05305b;         /* bleu marine */
  --accent:#00a897;         /* vert-bleu */
  --ink:#1b2a34;
  --muted:#5f6b73;
  --surface:#ffffff;
  --surface-2:#f6f8fb;
  --bd: rgba(15,23,42,.08);
  --ring: rgba(0,168,151,.25);
}

/* ================== Base ================== */
*{ box-sizing: border-box; }
img, iframe{ max-width: 100%; display:block; }
.contact-page{
  max-width: 1100px;
  margin: 24px auto 0;
  padding: 64px 28px;
  background: var(--surface-2);
  color: var(--ink);
  border-radius: 16px;
  border: 1px solid var(--bd);
  box-shadow: 0 10px 24px rgba(0,0,0,.06);
  position: relative;
  overflow-x: hidden; /* pas de scroll horizontal */
}

/* ================== Header & Breadcrumb ================== */
.contact-header{ text-align:center; margin-bottom: 12px; }
.contact-header h1{
  margin:0;
  font-size: clamp(22px, 3vw, 34px);
  font-weight: 900; letter-spacing:.01em; color: var(--brand);
  position: relative; display:inline-block; padding-bottom: 8px;
}
.contact-header h1::after{
  content:""; position:absolute; left:50%; bottom:0; transform: translateX(-50%);
  width: 82px; height: 3px; border-radius: 999px; background: linear-gradient(90deg,var(--brand),var(--accent));
}

.breadcrumb{
  display:flex; gap:6px; justify-content:center;
  font-size:12px; color:#8aa1ad; margin: 8px 0 24px;
}
.breadcrumb a{ color:#3a5563; text-decoration:none; }
.breadcrumb a:hover{ color: var(--brand); }

/* ================== Layout ================== */
.contact-content{
  display:grid; grid-template-columns: 1fr 1fr; gap: 28px;
}
@media (max-width: 980px){
  .contact-page{ padding: 56px 18px; }
  .contact-content{ grid-template-columns: 1fr; }
}

/* ================== Panels / Cards ================== */
.panel{
  background:#fff;
  border: 1px solid var(--bd);
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 6px 18px rgba(0,0,0,.05);
}
.contact-info{ composes: panel; }     /* (annotation: juste informatif) */
.contact-form{ composes: panel; }

.contact-info h2, .contact-form h2{
  margin:0 0 10px; font-size:18px; font-weight:800; color: var(--brand);
}

/* ================== Google Map ================== */
.map-container{
  border-radius: 12px; overflow: hidden; background:#e9eef1;
  border:1px solid var(--bd); box-shadow: 0 6px 16px rgba(0,0,0,.06);
  aspect-ratio: 16/10; margin-bottom: 16px;
}
.map-container iframe{ width:100%; height:100%; border:0; }

/* ================== Infos ================== */
.contact-info ul{
  list-style:none; padding:0; margin: 8px 0 0; color:#34495e; line-height:1.65;
}
.contact-info li{ margin-bottom:10px; font-size:15px; position:relative; padding-left:14px; }
.contact-info li::before{
  content:""; position:absolute; left:0; top:.62em;
  width:6px; height:6px; border-radius:999px; background: var(--accent);
}
.contact-info li strong{ color:#203341; }

/* ================== Formulaire ================== */
.form-group{ margin-bottom: 14px; }
label{
  display:block; margin-bottom:6px; color:#22313a; font-weight:700; font-size:13px;
}
input[type="text"],
input[type="email"],
textarea{
  width:100%;
  background:#fff; color:#0f1720;
  border:1px solid rgba(0,0,0,.16);
  border-radius:10px;
  font-size:15px; padding:12px 12px;
  transition: border-color .15s, box-shadow .2s, background .2s;
  outline: none;
}
textarea{ min-height:150px; resize: vertical; }
input:focus, textarea:focus{
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--ring);
}

/* Bouton */
button{
  display:inline-flex; align-items:center; justify-content:center; gap:8px;
  padding:12px 18px; border:0; border-radius:12px;
  background: linear-gradient(180deg, var(--accent), #00998B);
  color:#121212; font-weight:900; letter-spacing:.02em; font-size:14px; cursor:pointer;
  box-shadow: 0 12px 24px rgba(0,153,139,.22);
  transition: transform .12s, box-shadow .2s, filter .2s;
}
button:hover{ transform: translateY(-1px); filter: brightness(1.05); box-shadow: 0 16px 30px rgba(0,153,139,.28); }
button:active{ transform: translateY(0); }
@media (max-width: 520px){ button{ width:100%; } }

/* ================== Ajustements Tablette/Mobile ================== */
@media (max-width: 980px){
  .map-container{ aspect-ratio: 16/12; }
}
@media (max-width: 520px){
  .panel{ padding:16px; border-radius:12px; }
  .contact-info ul li, .contact-form p{ font-size:14px; }
}

/* ================== Mode sombre auto ================== */
@media (prefers-color-scheme: dark){
  .contact-page{
    background:#0e1720; color:#e6edf1; border-color: rgba(255,255,255,.06);
    box-shadow: 0 12px 32px rgba(0,0,0,.45);
  }
  .contact-header h1{ color:#e5ecff; }
  .breadcrumb{ color:#9fb3c8; }
  .breadcrumb a{ color:#73d8cf; } .breadcrumb a:hover{ color:#a5f3ee; }

  .panel{
    background:#0f1720; border-color: rgba(255,255,255,.06);
    box-shadow: 0 10px 24px rgba(0,0,0,.55);
  }
  label{ color:#d7e6ea; }
  .contact-info ul{ color:#cfe0e4; }
  .contact-info li::before{ background:#22c2b3; }

  input[type="text"], input[type="email"], textarea{
    background:#0f1a24; color:#e6edf1;
    border-color: rgba(255,255,255,.12);
  }
  input:focus, textarea:focus{
    border-color:#28c0b2; box-shadow: 0 0 0 3px rgba(0,153,139,.28);
  }

  .map-container{ background:#0f1a24; border-color: rgba(255,255,255,.08); box-shadow: 0 8px 22px rgba(0,0,0,.55); }

  button{
    background: linear-gradient(180deg, #00a897, #00998B);
    box-shadow: 0 12px 26px rgba(0,0,0,.55);
  }
}
</style>


